import * as effects from 'redux-saga/effects';
import { chatActions } from '../../actions';
import { handleError } from '../../../handleError';

export function* loadMoreMessages({
  payload,
}) {
  try {
    yield effects.put(chatActions.startFetching());
    // const response = yield effects.apply(api, api.get, [
    //   { endpoint: payload.url, direct: true },
    // ]);
    // if (!response.ok) {
    //   yield throwError(response);
    // }
    // const data = yield effects.call([
    //   response,
    //   'json',
    // ]);
    // if (payload.isNext) {
    //   yield effects.put(projectsActions.pushMoreMessages({ data, chatId: payload.chatId }));
    // }
    // if (payload.isPrev) {
    //   yield effects.put(projectsActions.pushPrevMoreMessages({ data, chatId: payload.chatId }));
    // }
  } catch (e) {
    yield handleError(e);
  } finally {
    yield effects.put(chatActions.stopFetching());
  }
}
